module.exports = __webpack_public_path__ + "img/ecommerce.18d5f1f0.svg";